import React from 'react'
// libs
import styled from 'styled-components'
import { useRouter } from 'hooks/useRouter'
import { useMutation } from '@apollo/client/react'
import { InjectedFormProps, reduxForm } from 'redux-form'
// constants
import { Forms } from 'constants/forms'
// components
import { ReduxInput } from 'components/FormElements'
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE } from 'components/UI'
// graphql
import { USER_UPDATE_MUTATION } from 'graphql/user/mutations'
// utils
import { handleError } from 'utils/errors/handlers'
import { password, required } from 'utils/validators'

const Form = styled.form`
  display: flex;
  flex-direction: column;

  & > :last-child {
    margin-top: 40px;
  }
`

interface Props {
  hideModal: () => void
}

const PasswordChangeForm: React.FC<InjectedFormProps<any, Props> & Props> = ({ hideModal, handleSubmit }) => {
  const router = useRouter()

  const [updateUserMutation] = useMutation(USER_UPDATE_MUTATION)

  const onFormSubmit = async (data: { password: string }) => {
    try {
      await updateUserMutation({
        variables: {
          id: router.query.id as string,
          companyId: router.query.companyId as string,
          user: {
            password: data.password
          }
        }
      })

      hideModal()
    } catch (error) {
      handleError(error, 'PasswordChangeModal.onFormSubmit')
    }
  }

  return (
    <Form onSubmit={handleSubmit(onFormSubmit)}>
      <ReduxInput label='Password' name='password' type='password' validate={[required, password]} />

      <Button type='submit' layout={BUTTON_LAYOUTS.PURPLE} style={CREATE_BUTTON_STYLE}>
        Save
      </Button>
    </Form>
  )
}

export default reduxForm<any, Props>({
  form: Forms.USER_PASSWORD_EDIT_FORM,
  enableReinitialize: true
})(PasswordChangeForm)
